import type { TaxonomyListRow } from '@/entities/taxonomy-list';

/**
 * Copies each row's source cell into the target columns where they are blank.
 *
 * A one-time copy, never a live link: codes end up inside minted names, so a later edit to
 * the source column must not rewrite them. Cells that already hold a value are left alone.
 */
export function fillEmptyCells(
  rows: readonly TaxonomyListRow[],
  sourceColumnId: string,
  targetColumnIds: readonly string[],
  clamp: (value: string) => string = (v) => v,
): { rows: TaxonomyListRow[]; filled: number } {
  let filled = 0;
  const next = rows.map((row) => {
    const source = (row.cells[sourceColumnId] ?? '').trim();
    if (!source) return row;
    const cells = { ...row.cells };
    for (const id of targetColumnIds) {
      if (id === sourceColumnId || (cells[id] ?? '').trim()) continue;
      cells[id] = clamp(source);
      filled += 1;
    }
    return { ...row, cells };
  });
  return { rows: next, filled };
}
